import React from 'react';
import Header from './components/header';
import SwipeData from './components/swipeData';
import MarkupData from './components/markupData';
import Followups from './components/followups';
import IndexDataProvider from './components/indexDataProvider';

const App = ({ summary, project, focus }) => {
  return (
    <IndexDataProvider summary={ summary } project={ project } focus={ focus }>
      <Header />
      <div className="page">
        { focus.need_swipe && <SwipeData /> }
        { focus.need_markup && <MarkupData /> }
        <Followups />
      </div>
    </IndexDataProvider>
  );
};

export default App;
